import { useEffect, useState } from "react";
import DashboardLayout from "../Layouts/DashboardLayout";

export default function PayrollAttendance() {
  const [staff, setStaff] = useState([]);
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);

  useEffect(() => {
    loadAttendance();
  }, [month, year]);

  const loadAttendance = async () => {
    try {
      const res = await fetch(
        `/api/attendance?month=${month}&year=${year}`,
        {
          credentials: "include",
        },
      );

      const data = await res.json();

      if (data.status === "success") {
        setStaff(data.data);
        console.log(data.data);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const daysInMonth = Array.from({ length: 31 }, (_, i) => i + 1);

  return (
    <DashboardLayout>
      <div className="space-y-8">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-serif">Staff Attendance</h1>

          <div className="flex gap-3">
            <select
              value={month}
              onChange={(e) => setMonth(Number(e.target.value))}
              className="bg-black border border-zinc-700 rounded px-3 py-2"
            >
              {Array.from({ length: 12 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {new Date(0, i).toLocaleString("default", {
                    month: "long",
                  })}
                </option>
              ))}
            </select>

            <input
              type="number"
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
              className="bg-black border border-zinc-700 rounded px-3 py-2 w-28"
            />
          </div>
        </div>

        <div className="rounded-2xl bg-white/5 border border-white/10 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-black/40 text-gray-400">
              <tr>
                <th className="px-6 py-4 text-left">Staff</th>
                <th className="px-6 py-4">Role</th>
                <th className="px-6 py-4">Days Present</th>
                <th className="px-6 py-4">Leaves</th>
                <th className="px-6 py-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {staff.map((s) => (
                <tr key={s.id} className="border-t border-white/10">
                  <td className="px-6 py-4">{s.staff_name}</td>
                  <td className="px-6 py-4 text-center">{s.role_name}</td>
                  <td className="px-6 py-4 text-center">{s.present_days}</td>
                  <td className="px-6 py-4 text-center">{s.leave_days}</td>
                  <td className="px-6 py-4 text-center space-x-4">
                    <button
                      onClick={() => {
                        setSelectedStaff(s);
                        setShowCalendar(false);
                      }}
                      className="text-amber-400 hover:underline"
                    >
                      View Leaves
                    </button>

                    <button
                      onClick={() => {
                        setSelectedStaff(s);
                        setShowCalendar(true);
                      }}
                      className="text-emerald-400 hover:underline"
                    >
                      View Calendar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {selectedStaff && !showCalendar && (
          <Modal onClose={() => setSelectedStaff(null)}>
            <h2 className="text-xl font-serif mb-4">
              Leave Details – {selectedStaff.staff_name}
            </h2>

            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-lg bg-zinc-900 p-4">
                <p className="text-gray-400">Present</p>
                <p className="text-2xl font-bold text-green-400">
                  {selectedStaff.present_days}
                </p>
              </div>

              <div className="rounded-lg bg-zinc-900 p-4">
                <p className="text-gray-400">Leave</p>
                <p className="text-2xl font-bold text-yellow-400">
                  {selectedStaff.leave_days}
                </p>
              </div>

              <div className="rounded-lg bg-zinc-900 p-4">
                <p className="text-gray-400">Half Day</p>
                <p className="text-2xl font-bold text-blue-400">
                  {selectedStaff.half_day_days}
                </p>
              </div>

              <div className="rounded-lg bg-zinc-900 p-4">
                <p className="text-gray-400">Absent</p>
                <p className="text-2xl font-bold text-red-400">
                  {selectedStaff.absent_days}
                </p>
              </div>
            </div>

            <hr className="my-5 border-zinc-700" />

            <h3 className="font-semibold mb-3">Leave Dates</h3>

            <div className="space-y-2 max-h-60 overflow-y-auto">
              {selectedStaff.leave_dates.length === 0 ? (
                <p className="text-gray-400">No leave taken.</p>
              ) : (
                selectedStaff.leave_dates.map((d) => (
                  <div
                    key={d}
                    className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg px-4 py-2"
                  >
                    {new Date(d).toLocaleDateString()}
                  </div>
                ))
              )}
            </div>
          </Modal>
        )}

        {selectedStaff && showCalendar && (
          <Modal onClose={() => setSelectedStaff(null)}>
            <h2 className="text-xl font-serif mb-6">
              Attendance Calendar – {selectedStaff.staff_name}
            </h2>

            <div className="grid grid-cols-7 gap-3">
              {daysInMonth.map((day) => {
                const date = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
                const isLeave = selectedStaff.leave_dates.includes(date);

                const isPresent = selectedStaff.present_dates.includes(date);

                const isHalfDay = selectedStaff.half_day_dates.includes(date);

                const isAbsent = selectedStaff.absent_dates.includes(date);

                return (
                  <div
                    key={day}
                    className={`p-3 rounded-lg text-center border text-sm
  ${
    isPresent
      ? "bg-green-500/20 border-green-500 text-green-400"
      : isLeave
        ? "bg-yellow-500/20 border-yellow-500 text-yellow-400"
        : isHalfDay
          ? "bg-blue-500/20 border-blue-500 text-blue-400"
          : isAbsent
            ? "bg-red-500/20 border-red-500 text-red-400"
            : "bg-zinc-900 border-zinc-700 text-gray-500"
  }`}
                  >
                    {day}
                  </div>
                );
              })}
            </div>
          </Modal>
        )}
      </div>
    </DashboardLayout>
  );
}

function Modal({ children, onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
      <div className="w-full max-w-4xl rounded-2xl bg-[#0b0b0f] border border-white/10 p-8 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
}
